import {Button, DialogActions,DialogContent} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';

export type GenelcoUploadInternalSystemErrorModalProps = {
  onClose: () => void;
};
const GenelcoUploadInternalSystemErrorModal = (props: GenelcoUploadInternalSystemErrorModalProps) => {
  const {onClose} = props;
  return (
    <Modal open onClose={onClose} title="Internal System Error">
      <div className="card__dialog">
        <DialogContent>File has encountered a system error. Our team is working on resolving the issue as quickly as possible.</DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default GenelcoUploadInternalSystemErrorModal;
